const objectToQueryParams = (obj = {}) => {
  const params = Object.entries(obj)
    .filter(([, value]) => value !== undefined && value !== null)
    .reduce(
      (acc, [key, value]) =>
        acc.concat(Array.isArray(value) ? value.map(singleValue => [`${key}[]`, singleValue]) : [[key, value]]),
      []
    )
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)

  return params.length > 0 ? `?${params.join('&')}` : ''
}

export default objectToQueryParams
